import React from 'react';

import 'assets/scss/components/loaders/spinner.scss';



export function Spinner(props) {
    const { className, size, isLeftMarginOptional, isColorPrimary } = props;

    let spinnerSize = "spinner-border";
    switch (size) {
        case 0:
            spinnerSize = "spinner-border-sm";
        default:
            break;
    }

    return(
        <div className={"spinner spinner-border " + 
                (className? className + " ":"") +
                (isLeftMarginOptional? "":"ml-2 ") + 
                (spinnerSize? spinnerSize + " ":"") +
                (isColorPrimary? "spinner_primary ":"")} 
            role="status"
        >
            <span className="sr-only">Loading...</span>
        </div>
    );
}